module.exports = __webpack_public_path__ + "img/upload-avatar.f7f751b1.png";